export function PaginationSkeleton() {
  return (
    <div className="px-4 sm:px-6 xl:px-4xl">
      <div className="mt-8 flex items-center justify-center gap-2">
        <div className="w-8 h-8 skeleton-item rounded skeleton-stagger-1"></div>
        <div className="flex gap-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className={`w-8 h-8 skeleton-item rounded skeleton-stagger-${i + 1}`}></div>
          ))}
        </div>
        <div className="w-8 h-8 skeleton-item rounded skeleton-stagger-5"></div>
        <div className="ml-4 w-24 h-8 skeleton-item rounded skeleton-stagger-6"></div>
      </div>
    </div>
  );
}
